import { Component, OnInit, TemplateRef  } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';

import * as moment from 'moment';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { LoginService } from 'src/app/modules/distributor/services/login.service';

@Component({
  selector: 'app-distributor-login',
  templateUrl: './distributor-login.component.html',
  styleUrls: ['./distributor-login.component.scss']
})
export class DistributorLoginComponent implements OnInit {

  public loginForm: FormGroup;
  public buttonLoader: any = false;

  public pushNotificationToken: any;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _loginService: LoginService,
  ) {}

  ngOnInit(): void {
    // Set login form
    this.loginForm = new FormGroup({
      username: new FormControl(null, [Validators.required, Validators.minLength(3)]),
      password: new FormControl(null, [Validators.required, Validators.minLength(3)]),
    });
  }

  // Login submit
  async onLogin() {
    if (this.loginForm.value.username && this.loginForm.value.password) {
      let userLoginBody = {
        mode: 'DISTRIBUTOR',
        username: this.loginForm.value.username,
        password: this.loginForm.value.password
      };

      this.buttonLoader = true;

      // Check username & password
      this._loginService.userLogin(userLoginBody).subscribe(async userLoginResponse => {
        if (userLoginResponse.status === true) { // Success
          // Get retailer, category, manufacturer & brand list
          let getRetailersBody = {
            provider_type: userLoginResponse.user_details.provider_type,
            provider_id: userLoginResponse.user_details.provider_id,
            coupon_count: true
          };
          
          forkJoin([
            this._loginService.getRetailers(userLoginResponse.token, getRetailersBody),
            this._loginService.getCategories(userLoginResponse.token, userLoginResponse.user_details.provider_type, userLoginResponse.user_details.provider_id),
            this._loginService.getManufacturers(userLoginResponse.token, userLoginResponse.user_details.provider_type, userLoginResponse.user_details.provider_id, true),
            this._loginService.getBrands(userLoginResponse.token, userLoginResponse.user_details.provider_type, userLoginResponse.user_details.provider_id, 0),
          ]).subscribe(async results => {
            this.buttonLoader = false;

            if (results[0].status === true && results[1].status === true && results[2].status === true && results[3].status === true) { // Success
              // Add login data to local storage
              let responseSetStorageDataC_LOGIN = await this._utilService.setStorageData('D_LOGIN', userLoginResponse);
              let responseSetStorageDataC_RETAILERS = await this._utilService.setStorageData('D_RETAILERS', results[0].retailers);
              let responseSetStorageDataC_CATEGORIES = await this._utilService.setStorageData('D_CATEGORIES', results[1].categories);
              let responseSetStorageDataC_MANUFACTURERS = await this._utilService.setStorageData('D_MANUFACTURERS', results[2].manufacturers);
              let responseSetStorageDataC_BRANDS = await this._utilService.setStorageData('D_BRANDS', results[3].brands);

              if (responseSetStorageDataC_LOGIN && responseSetStorageDataC_RETAILERS && responseSetStorageDataC_MANUFACTURERS && responseSetStorageDataC_BRANDS) {
                this._router.navigate(['/distributor/coupon-list']); // Go to CPG Coupon List
              } else {
                this._utilService.showToast('Error while saving login data', '', 'error', {});
              }
            } else {
              if (results[0].status === true) { // Error from getRetailers call
                this._utilService.showToast(results[0].message, '', 'error', {});
              } else if (results[1].status === true) { // Error from getCategories call
                this._utilService.showToast(results[1].message, '', 'error', {});
              } else if (results[2].status === true) { // Error from getManufacturers call
                this._utilService.showToast(results[2].message, '', 'error', {});
              } else { // Error from getBrands call
                this._utilService.showToast(results[3].message, '', 'error', {});
              }
            }
          }, error2 => { // Error from getRetailers
            this.buttonLoader = false;
            this._utilService.showToast(environment.apiErrorMessage, '', 'error', {});
          });
        } else {
          this.buttonLoader = false;
          this._utilService.showToast(userLoginResponse.message, '', 'error', {});
        }
      }, error1 => { // Error from userLogin
        this.buttonLoader = false;
        this._utilService.showToast(environment.apiErrorMessage, '', 'error', {});
      });
    }
  }

}
